// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__RJxmW","footerSocials":"footer_footerSocials__mmyrn","exploreLink":"footer_exploreLink__gx+s5"};